import type { CSSProperties, ReactNode } from 'react'
import {
  MARKETING_CONTENT_COLUMN_CLASS,
  marketingContentColumnStyle,
} from '@/landing/marketing-layout-tokens'
import { cn } from '@/lib/utils'

type MarketingContentFrameProps = {
  children: ReactNode
  /** Classes on the content column (flex, gaps, vertical rhythm, etc.). */
  className?: string
  /**
   * Extra classes merged onto the same column (e.g. vertical spacing).
   * Horizontal gutters live on the column via margins — do not reintroduce shell padding.
   */
  shellClassName?: string
  maxWidth?: number
  style?: CSSProperties
}

/**
 * Marketing content column: true max-width with margin gutters (not padding).
 */
export function MarketingContentFrame({
  children,
  className,
  shellClassName,
  maxWidth,
  style,
}: MarketingContentFrameProps) {
  return (
    <div
      className={cn(MARKETING_CONTENT_COLUMN_CLASS, shellClassName, className)}
      style={{ ...marketingContentColumnStyle(maxWidth), ...style }}
    >
      {children}
    </div>
  )
}
